import { env } from "@/env";

export const VERIFICATION_CODE_LENGTH = 6;
export const VERIFICATION_CODE_RESEND_TIMEOUT_IN_SECONDS = env.DEV ? 5 : 30;

export const TRAVEL_EXPENSE_TYPE = ["CAR", "PUBLIC_TRANSPORT", "OTHER"] as const;
export type TravelExpenseType = (typeof TRAVEL_EXPENSE_TYPE)[number];
